import React, { useContext, useEffect } from "react";

import ReducerContext from "../../shared/ReducerContext";
import setClientState from "./setClientState";

const wrapSetClient = ({ Component, feature }) => props => {
  const { state } = useContext(ReducerContext);

  useEffect(() => {
    if (state) {
      setClientState({ data: state, feature });
    }
  }, [state]);

  return <Component {...props} />;
};

export default wrapSetClient;
